import { createPortal } from "react-dom";
import { useEffect, useState } from "react";

const ProgressBar = ({ isActionLoading }: { isActionLoading: boolean }) => {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted) return null;

  const actionLoadingClass = isActionLoading ? 'fixed inset-0 z-9998 pointer-events-auto touch-none bg-white/30' : ''

  return createPortal(
    <div
      className={`${actionLoadingClass} flex items-end justify-center`}
      onMouseDown={(e) => e.stopPropagation()}
      onClick={(e) => e.stopPropagation()}
    >
      <div className=" absolute z-9999 bottom-16 left-1/8 h-1 w-3/4 overflow-hidden rounded bg-gray-300">
        <div className="h-full animate-loading bg-blue-500" />
      </div>
    </div>,
    document.body
  );
};

export default ProgressBar;


